<template>
  <section class="section-base form-section-base form-base">
    <v-container>
      <div class="form-section-base__title">
        {{ ApplicantRightholderText.TITLE }}
      </div>

      <Person :v="$v.person" />

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import Person, { personModel, personValidation } from '../Person';
import { ApplicantRightholderText } from '@/constants';

export default {
  name: 'Manual',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Person,
    Footer,
  },
  data() {
    return {
      StepDirection,
      leaveStep,
      StepName,
      invalidFields: [],
      person: cloneDeep(personModel),
      ApplicantRightholderText,
    };
  },
  validations() {
    return {
      person: personValidation(this.person),
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    touchFields() {
      this.invalidFields = [];

      this.$v.person.$touch();
      checkInvalid(this.$v.person, this.invalidFields);
    },

    prefillDraft() {
      const applicantStore = cloneDeep(
        ServicesModule.statement.subjects.applicantRightholder
      );

      if (!applicantStore?.person) {
        return;
      }

      this.person = deepmerge(personModel, applicantStore.person);

      if (this.person.isTrustee) {
        this.person.trustee = deepmerge(
          personModel.trustee,
          applicantStore.trustee
        );
      }
    },

    assemblyModel() {
      const applicant = {};

      applicant.person = cloneDeep(this.person);

      if (applicant.person.isTrustee) {
        applicant.trustee = cloneDeep(this.person.trustee);
        applicant.person.phone = null;
      }

      return applicant;
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StepName.S4,
      });
    },
  },
};
</script>
